import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';
import emailjs from 'emailjs-com';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Modal from 'react-modal';
import 'primereact/resources/themes/lara-light-blue/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';               
import 'primeicons/primeicons.css';                             

import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import App from './App';
import Argitechmain from './pages/ArgiTech/Argitechmain';
import Argitech1 from './pages/ArgiTech/Argitech1';
import Argitech2 from './pages/ArgiTech/Argitech2';
import Argitech3 from './pages/ArgiTech/Argitech3';
import Argitech4 from './pages/ArgiTech/Argitech4';
import Argitech5 from './pages/ArgiTech/Argitech5';
import Argitech6 from './pages/ArgiTech/Argitech6';
import Argitech7 from './pages/ArgiTech/Argitech7';
import { CountryProvider } from './pages/CountryContext';

import News from './pages/News/News';
import New1 from './pages/News/New1';
import { ContentProvider } from './pages/ContentContext';
import New2 from './pages/News/New2';
import New3 from './pages/News/New3';
import Document from './components/PDFPreviewPage';
import Verification from './pages/Verification/Verification';
import ExperienceMain from './pages/ExperienceFarmnetApp/ExperienceMain';
import Experience1 from './pages/ExperienceFarmnetApp/Experience1';
import Experience2 from './pages/ExperienceFarmnetApp/Experience2';
import Experience3 from './pages/ExperienceFarmnetApp/Experience3';
import Experience4 from './pages/ExperienceFarmnetApp/Experience4';
import Experience5 from './pages/ExperienceFarmnetApp/Experience5';
import Experience6 from './pages/ExperienceFarmnetApp/Experience6';
import Experience7 from './pages/ExperienceFarmnetApp/Experience7';
import Experience8 from './pages/ExperienceFarmnetApp/Experience8';
import VoiceOfFarmersMain from './pages/VoiceOFFamers/VoiceoffarmerMain';
import Voice1 from './pages/VoiceOFFamers/Voice1';
import Voice2 from './pages/VoiceOFFamers/Voice2';
import Voice3 from './pages/VoiceOFFamers/Voice3';
import Voice4 from './pages/VoiceOFFamers/Voice4';
import Voice5 from './pages/VoiceOFFamers/Voice5';
import Voice6 from './pages/VoiceOFFamers/Voice6';
import Voice7 from './pages/VoiceOFFamers/Voice7';
import Voice8 from './pages/VoiceOFFamers/Voice8';
import Voice9 from './pages/VoiceOFFamers/Voice9';
import Voice10 from './pages/VoiceOFFamers/Voice10';
import Voice11 from './pages/VoiceOFFamers/Voice11';
import Voice12 from './pages/VoiceOFFamers/Voice12';
import InnovationMain from './pages/InsightsandInnovation/InnovationMain';
import Innovation1 from './pages/InsightsandInnovation/Innovation1';
import Innovation2 from './pages/InsightsandInnovation/Innovation2';
import Innovation3 from './pages/InsightsandInnovation/Innovation3';
import Innovation4 from './pages/InsightsandInnovation/Innovation4';
import Innovation5 from './pages/InsightsandInnovation/Innovation5';
import Innovation6 from './pages/InsightsandInnovation/Innovation6';
import Innovation7 from './pages/InsightsandInnovation/Innovation7';
import Innovation8 from './pages/InsightsandInnovation/Innovation8';


import Solutions from './pages/Solutions';
import Solutions1 from './pages/Solutions/Solutions1';
import Solutions2 from './pages/Solutions/Solutions3';
import Solutions3 from './pages/Solutions/Solutions4';
import Solutions4 from './pages/Solutions/Solutions5';
import Solutions5 from './pages/Solutions/Solutions6';
import Solutions6 from './pages/Solutions/Solutions6';
import Solutions7 from './pages/Solutions/Solutions7';
import Solutions8 from './pages/Solutions/Solutions8';
import Solutions9 from './pages/Solutions/Solutions9';
import Solutions10 from './pages/Solutions/Solutions10';
import Reports from './pages/Reports';
import Reports1 from './pages/Reports1';

import NewsMain from './pages/News/NewsMain';
import Market from './pages/Market/Market';

import Register_As_Farm from './pages/Register_As_Farm';
import Contact from './components/Contact';
import Terms_Condition from './pages/Safety/Terms_Condition';
import Data_Policy from './pages/Safety/Data_Policy';
import Privacy_Policy from './pages/Safety/Privacy_Policy';
import Faqs from './pages/Safety/Faqs';
import Communities from './pages/Communities';
import AppLaunch from './pages/AppLaunch';
import About from './pages/About';
import Advisor from './pages/Organizers/Advisor';
import Advisor1 from './pages/Organizers/Advisor1';
import Advisor2 from './pages/Organizers/Advisor2';
import Advisor3 from './pages/Organizers/Advisor3';
import Advisor4 from './pages/Organizers/Advisor4';
import Advisor5 from './pages/Organizers/Advisor5';
import Advisor6 from './pages/Organizers/Advisor6';
import Country from './pages/Organizers/Country';
import Country1 from './pages/Organizers/Country1';
import Country2 from './pages/Organizers/Country2';
import Country3 from './pages/Organizers/Country3';
import Country4 from './pages/Organizers/Country4';
import Country5 from './pages/Organizers/Country5';

import MoreReportPage from './pages/MoreReport/MoreReportPage';
import MoreReportPage2 from './pages/MoreReport/MoreReportPage2';
import MoreReportPage3 from './pages/MoreReport/MoreReportPage3';

import Resources from './pages/Resources';
import CommunityPage1 from './pages/Communities/CommunityPage1';
import CommunityPage2 from './pages/Communities/CommunityPage2';
import CommunityPage3 from './pages/Communities/CommunityPage3';
import CommunityPage4 from './pages/Communities/CommunityPage4';
import CommunityPage5 from './pages/Communities/CommunityPage5';
import CommunityPage6 from './pages/Communities/CommunityPage6';
import CommunityPage7 from './pages/Communities/CommunityPage7';
import CommunityPage8 from './pages/Communities/CommunityPage8';
import CommunityPage9 from './pages/Communities/CommunityPage9';
import CommunityPage10 from './pages/Communities/CommunityPage10';
import CommunityPage11 from './pages/Communities/CommunityPage11';
import CommunityPage12 from './pages/Communities/CommunityPage12';
import EsgPage1 from './pages/ESG/EsgPage1';
import EsgPageMore1 from './pages/ESG/EsgPageMore1';



import Adopt1 from './pages/Communities/AdoptFarm/Adopt1';
import Adopt2 from './pages/Communities/AdoptFarm/Adopt2';
import Adopt3 from './pages/Communities/AdoptFarm/Adopt3';
import Adopt4 from './pages/Communities/AdoptFarm/Adopt4';


import ReportsRegistrationPage from './pages/MoreReport/ReportsRegistrationPage';
 
import Donate1 from './pages/Communities/Donate/Donate1';
import Ubuntu from './pages/Communities/UbuntuCommunity/Ubuntu';
import EsgPage2 from './pages/ESG/EsgPage2';
import EsgPage3 from './pages/ESG/EsgPage3';

import EsgPageMore2 from './pages/ESG/EsgPageMore2';
import EsgPageMore3 from './pages/ESG/EsgPageMore3';
import Advisor7 from './pages/Organizers/Advisor7';
import ResourcesPage1 from './pages/Resources/ResourcesPage1';
import Gallery from './pages/Gallery';
import GalleryPage1 from './pages/Gallery/GalleryPage1';
import RegisterOrganization from './pages/RegisterOrganization';
import SMEChallenges from './components/SMEChallenges';
import BenefitsOfRegistration from './components/BenefitsRegistration';
import ViewMoreReport from './pages/MoreReport/ViewMoreReport';
import ViewMoreReport1 from './pages/ViewMoreReport1';
import Policy from './pages/Policy';
import Login from './pages/Login/Log_in';

import Adminportal from '../src/Admin/pages/UserAccount';
import ViewContract from './pages/Market/ViewContract';
import ContractMain from './pages/Contract/ContractMain';
import Contract1th from './pages/Contract/Contract1th';
import Contract2th from './pages/Contract/Contract2th';
import Contract3th from './pages/Contract/Contract3th';
import Contract4th from './pages/Contract/Contract4th';

import ContractDocument from './pages/Contract/ContractDocument';
import Calendar from './pages/Calendar/Calendar';
import Admin_Report from './Admin/pages/Admin_Report';
import Admin_Communication from './Admin/pages/Admin_Communication';
import Admin_Topbanner from './Admin/pages/TopBannerMainPage';
import BakeryCatalogue from './pages/Catalgoue/Catalogue';






Modal.setAppElement('#root');
const RootApp = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }
  emailjs.init('_i_23nZZB1-fY8buk'); // Your user ID
  Modal.setAppElement('#root');
  return (
    <CountryProvider>
    <ContentProvider>

    <Router>
      <ScrollToTop />
      <Navbar />
    
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="argitechmain" element={<Argitechmain />} />
        <Route path="argitech1" element={<Argitech1 />} />
        <Route path="argitech2" element={<Argitech2 />} />
        <Route path="argitech3" element={<Argitech3 />} />
        <Route path="argitech4" element={<Argitech4 />} />
        <Route path="argitech5" element={<Argitech5 />} />
        <Route path="argitech6" element={<Argitech6 />} />
        <Route path="argitech7" element={<Argitech7 />} />


        <Route path="news" element={<News />} />
        <Route path="new1" element={<New1 />} />
        <Route path="new2" element={<New2 />} />
        <Route path="new3" element={<New3 />} />
        <Route path="experiencemain" element={<ExperienceMain />} />
        <Route path="experience1" element={<Experience1 />} />
        <Route path="experience2" element={<Experience2 />} />
        <Route path="experience3" element={<Experience3 />} />
        <Route path="experience4" element={<Experience4 />} />
        <Route path="experience5" element={<Experience5 />} />
        <Route path="experience6" element={<Experience6 />} />
        <Route path="experience7" element={<Experience7 />} />
        <Route path="experience8" element={<Experience8 />} />
        <Route path="voiceoffarmermain" element={<VoiceOfFarmersMain />} />
        <Route path="voice1" element={<Voice1 />} />
        <Route path="voice2" element={<Voice2 />} />
        <Route path="voice3" element={<Voice3 />} />
        <Route path="voice4" element={<Voice4 />} />
        <Route path="voice5" element={<Voice5 />} />
        {/* <Route path="voice6" element={<Voice6 />} />
        <Route path="voice7" element={<Voice7 />} />
        <Route path="voice8" element={<Voice8 />} />
        <Route path="voice9" element={<Voice9 />} />
        <Route path="voice10" element={<Voice10 />} />
        <Route path="voice11" element={<Voice11 />} />
        <Route path="voice12" element={<Voice12 />} /> */}
        <Route path="InnovationMain" element={<InnovationMain />} />
        <Route path="innovation1" element={<Innovation1 />} />
        <Route path="innovation2" element={<Innovation2 />} />
        <Route path="innovation3" element={<Innovation3 />} />
        <Route path="innovation4" element={<Innovation4 />} />
        <Route path="innovation5" element={<Innovation5 />} />
        <Route path="innovation6" element={<Innovation6 />} />
        <Route path="innovation7" element={<Innovation7 />} />
        <Route path="innovation8" element={<Innovation8 />} />

        <Route path="solutions" element={<Solutions />} />
        <Route path="solutions1" element={<Solutions1 />} />
        <Route path="solutions2" element={<Solutions2 />} />
        <Route path="solutions3" element={<Solutions3 />} />
        <Route path="solutions4" element={<Solutions4 />} />
        <Route path="solutions5" element={<Solutions5 />} />
        <Route path="solutions6" element={<Solutions6 />} />
        <Route path="solutions7" element={<Solutions7 />} />
        <Route path="solutions8" element={<Solutions8 />} />
        <Route path="solutions9" element={<Solutions9 />} />
        <Route path="solutions10" element={<Solutions10 />} />
        <Route path="reports" element={<Reports/>} />
        <Route path="reports1" element={<Reports1/>} />

        <Route path="NewsMain" element={<NewsMain/>} />
        <Route path="Register_As_Farm" element={<Register_As_Farm/>} />
        <Route path="Contact" element={<Contact/>} />
        <Route path="Terms_Condition" element={<Terms_Condition/>} />
        <Route path="Data_Policy" element={<Data_Policy/>} />
        <Route path="PrivacyPolicy" element={<Privacy_Policy/>} />
        <Route path="Faqs" element={<Faqs/>} />
        <Route path="communities" element={<Communities/>} />
        <Route path="communitypage1" element={<CommunityPage1/>} />
        <Route path="communitypage2" element={<CommunityPage2/>} />
        <Route path="communitypage3" element={<CommunityPage3/>} />
        <Route path="communitypage4" element={<CommunityPage4/>} />
        <Route path="communitypage5" element={<CommunityPage5/>} />
        <Route path="communitypage6" element={<CommunityPage6/>} />

        <Route path="communitypage7" element={<CommunityPage7/>} />
        <Route path="communitypage8" element={<CommunityPage8/>} />
        <Route path="communitypage9" element={<CommunityPage9/>} />
        <Route path="communitypage10" element={<CommunityPage10/>} />
        <Route path="communitypage11" element={<CommunityPage11/>} />
        <Route path="communitypage12" element={<CommunityPage12/>} />



        <Route path="AppLaunch" element={<AppLaunch/>} />
        <Route path="About" element={<About/>} />
        <Route path="Advisor" element={<Advisor/>} />
        <Route path="Advisor1" element={<Advisor1/>} />
        <Route path="Advisor2" element={<Advisor2/>} />
        <Route path="Advisor3" element={<Advisor3/>} />
        <Route path="Advisor4" element={<Advisor4/>} />
        <Route path="Advisor5" element={<Advisor5/>} />
        <Route path="Advisor6" element={<Advisor6/>} />
        <Route path="Advisor7" element={<Advisor7/>} />
        <Route path="Country" element={<Country/>} />
        <Route path="Country1" element={<Country1/>} />
        <Route path="Country2" element={<Country2/>} />
        <Route path="Country3" element={<Country3/>} />
        <Route path="Country4" element={<Country4/>} />
        <Route path="Country5" element={<Country5/>} />

        <Route path="MoreReportPage" element={<MoreReportPage/>} />
        <Route path="MoreReportPage2" element={<MoreReportPage2/>} />
        <Route path="MoreReportPage3" element={<MoreReportPage3/>} />

        <Route path="resources" element={<Resources/>} />
        <Route path="ResourcesPage1" element={<ResourcesPage1/>} />

        <Route path="Adopt1" element={<Adopt1/>} />
        <Route path="Adopt2" element={<Adopt2/>} />
        <Route path="Adopt3" element={<Adopt3/>} />
        <Route path="Adopt4" element={<Adopt4/>} />

        <Route path="Donate1" element={<Donate1/>} />
        <Route path="Ubuntu" element={<Ubuntu/>} />

        <Route path="EsgPage1" element={<EsgPage1/>} />
        <Route path="EsgPage2" element={<EsgPage2/>} />
        <Route path="EsgPage3" element={<EsgPage3/>} />

        <Route path="EsgPageMore1" element={<EsgPageMore1/>} />
        <Route path="EsgPageMore2" element={<EsgPageMore2/>} />
        <Route path="EsgPageMore3" element={<EsgPageMore3/>} />
        <Route path="Gallery" element={<Gallery/>} />
        <Route path="GalleryPage1" element={<GalleryPage1/>} />

        <Route path="RegisterOrganizaton" element={<RegisterOrganization/>} />
        <Route path="SMEChallenges" element={<SMEChallenges/>} />
        <Route path="ReportsRegistrationPage" element={<ReportsRegistrationPage/>} />
        <Route path="Document" element={<Document/>} />
        <Route path="Verification" element={<Verification/>} />

        <Route path="BenefitsOfRegistration" element={<BenefitsOfRegistration/>} />
        <Route path="ViewMoreReport" element={<ViewMoreReport/>} />

        <Route path="ViewMoreReport1" element={<ViewMoreReport1/>} /> 
        <Route path="Policy" element={<Policy/>} /> 
        <Route path="Adminportal" element={<Adminportal/>} /> 


        <Route path="Market" element={<Market/>} /> 
        <Route path="Contract" element={<ViewContract/>} /> 
        <Route path="ContractMain" element={<ContractMain/>} /> 
        <Route path="Contract1" element={<Contract1th/>} /> 
        <Route path="Contract2" element={<Contract2th/>} /> 
        <Route path="Contract3" element={<Contract4th/>} /> 
        <Route path="Contract4" element={<Contract3th/>} /> 
        <Route path="Catalogue" element={<BakeryCatalogue/>} /> 


        <Route path="ContractDocument" element={<ContractDocument/>} /> 


        
        <Route path="Calendar" element={<Calendar/>} /> 
        <Route path="Admin_Report" element={<Admin_Report/>} /> 
        <Route path="Admin_Communication" element={<Admin_Communication/>} /> 
        <Route path="topbannermainpage" element={<Admin_Topbanner/>} /> 




        {/* <Route path="Login" element={<Login/>} />  */}



      </Routes>
    
      <Footer />
      <div>
       
      </div>
    </Router>
    </ContentProvider>
      </CountryProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootApp />);
reportWebVitals();
